<template>
  <div class="menu-outer">
    <div class="menu">
      <button type="button" class="item" @click="open(blueskyUrl)">
        <svg class="icon" viewBox="0 0 600 530" fill="#0085ff">
          <path d="M135.72 44.03C202.216 93.976 273.74 195.17 300 249.49c26.262-54.316 97.782-155.514 164.28-205.46C512.26 8.009 590-19.862 590 68.825c0 17.712-10.155 148.79-16.111 170.07-20.703 73.984-96.144 92.854-163.25 81.433 117.3 19.964 147.14 86.092 82.697 152.22-122.39 125.59-175.91-31.511-189.63-71.766-2.514-7.38-3.69-10.832-3.708-7.896-.017-2.936-1.193.516-3.707 7.896-13.714 40.255-67.233 197.36-189.63 71.766-64.444-66.128-34.605-132.26 82.697-152.22-67.108 11.421-142.55-7.449-163.25-81.433C20.155 217.615 10 86.537 10 68.825c0-88.687 77.742-60.816 125.72-24.795z"/>
        </svg>
        Bluesky
      </button>
      <button type="button" class="item" @click="open(linkedInUrl)">
        <svg class="icon" viewBox="0 0 24 24" fill="#0A66C2">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
        LinkedIn
      </button>
      <button type="button" class="item" @click="open(twitterUrl)">
        <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
        Twitter / X
      </button>
    </div>
    <div class="pointer" />
  </div>
</template>

<script setup>
import {computed} from "vue";
const props = defineProps(["text"]);
const emit = defineEmits(["close"]);
const encoded = computed(() => encodeURIComponent(`${props.text || ""}\n\nhttps://vizbi.org`));
const linkedInUrl = computed(() => `https://www.linkedin.com/feed/?shareActive=true&text=${encoded.value}`);
const twitterUrl = computed(() => `https://twitter.com/intent/tweet?text=${encoded.value}`);
const blueskyUrl = computed(() => `https://bsky.app/intent/compose?text=${encoded.value}`);
function open(url) {
  window.open(url, "_blank", "noopener,noreferrer");
  emit("close");
}
</script>

<style scoped>
.menu-outer {
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  filter: drop-shadow(0 4px 16px rgba(0, 0, 0, 0.18));
  z-index: 20;
}
.menu {
  background: white;
  border-radius: 10px;
  overflow: hidden;
  min-width: 158px;
}
.item {
  display: flex !important;
  align-items: center;
  gap: 10px;
  width: 100% !important;
  flex: none !important;
  padding: 10px 14px !important;
  background: none !important;
  border: none !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07) !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  cursor: pointer;
  font-size: 14px !important;
  color: #333 !important;
  font-weight: 500 !important;
  text-align: left;
  font-family: inherit;
  line-height: 1.4 !important;
}
.item:last-of-type {
  border-bottom: none;
}
.item:hover {
  background: rgba(0, 0, 0, 0.04);
}
.icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.pointer {
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 12px;
  height: 12px;
  background: white;
}
</style>
